import React, {PureComponent} from "react";

class SubscriptionPlansHeader extends PureComponent {
    state = {
        disabled: this.props.disabled,
        planPeriod: this.props.planPeriod,
        activePlanInterval: this.props.activePlanInterval

    }
    setPlanPeriod = (interval) => {
        this.props.togglePlanPeriod(interval)
    }

    componentDidUpdate = () => {
        if (this.state.disabled !== this.props.disabled) {
            this.setState({
                disabled: this.props.disabled
            })
        }
        if (this.state.planPeriod !== this.props.planPeriod) {
            this.setState({
                planPeriod: this.props.planPeriod
            })
        }
        if (this.state.activePlanInterval !== this.props.activePlanInterval) {
            this.setState({
                activePlanInterval: this.props.activePlanInterval
            })
        }
    }

    render() {
        return (
            <React.Fragment>

                <div className="sm:flex sm:flex-col sm:align-center">
                    <h1 className="text-5xl font-bold text-darkText text-center">Pricing Plans</h1>
                    <p className="mt-5 text-xl text-center">Start small, scale as you grow. </p>
                    <div className="relative self-center mt-6 bg-gray-100 rounded-lg p-0.5 flex sm:mt-8">
                        <div
                            className="absolute -top-5 right-4 z-0 px-3 pt-1 bg-green font-semibold text-xs text-center bg-discountRed bg-opacity-50 text-white rounded-t-md">SAVE
                            20%
                        </div>
                        <button type="button"
                                disabled={this.state.activePlanInterval === 'year'}
                                onClick={() => this.setPlanPeriod('monthly')}
                                className=

                                    {`relative ${this.state.planPeriod === 'monthly' ? 'bg-white' : ''} w-1/2 text-lightText  border-gray-200 text-center rounded-md
                                         shadow-sm py-2 text-sm font-medium whitespace-nowrap sm:w-auto sm:px-8
                                        ${this.state.activePlanInterval === 'year' ? '' : 'hover:bg-emittoBlue hover:text-white'} cursor-pointer`}


                                id="monthlyBillingBtn">Monthly billing
                        </button>
                        <button type="button"
                                disabled={this.state.activePlanInterval === 'year'}
                                onClick={() => this.setPlanPeriod('yearly')}
                                className={`relative ${this.state.planPeriod === 'yearly' ? 'bg-white' : ''} w-1/2 text-lightText  border-gray-200 text-center rounded-md
                                         shadow-sm py-2 text-sm font-medium whitespace-nowrap sm:w-auto sm:px-8
                                        ${this.state.activePlanInterval === 'year' ? '' : 'hover:bg-emittoBlue hover:text-white'} cursor-pointer`}
                                id="yearlyBillingBtn">Yearly billing
                        </button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default SubscriptionPlansHeader;